import React from 'react';
import { ArrowLeft, Calendar, Shield, Users, FileText, Globe, AlertCircle } from 'lucide-react';
import { goHome } from '../utils/navigation';

const TermsAndConditions: React.FC = () => {
  const goBack = () => {
    goHome();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-dpn-pink/5 via-white to-dpn-olive/5">


      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Title Section */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-dpn-pink/10 rounded-full">
              <FileText className="h-12 w-12 text-dpn-pink" />
            </div>
          </div>
          <h1 className="text-4xl font-runtime font-bold text-gray-900 mb-4">
            Terms of Service
          </h1>
          <p className="text-lg text-gray-600 font-lucy-rose max-w-2xl mx-auto">
            Welcome to Durga Puja Network. Please read these terms and conditions carefully before using our platform.
          </p>
          <div className="mt-4 flex items-center justify-center text-sm text-gray-500">
            <Calendar className="h-4 w-4 mr-2" />
            <span>Last updated: 30.06.2025</span>
          </div>
        </div>

        {/* Terms Content */}
        <div className="bg-white rounded-2xl shadow-xl p-8 space-y-8">
          
          {/* Introduction */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-olive/10 rounded-lg mr-3">
                <Globe className="h-5 w-5 text-dpn-olive" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Introduction</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <h3 className="font-runtime font-semibold text-lg text-gray-800">Welcome to Durga Puja Network</h3>
              <p>
                Mind's Workstation India Pvt. Ltd is the licensed owner of the brand Durga Puja Network and the website www.durgapuja.network ("The Site").
              </p>
              <p>
                MIND'S WORKSTATION INDIA PVT. LTD respects your privacy. This Privacy Policy provides succinctly the manner your data is collected and used by MIND'S WORKSTATION INDIA PVT. LTD on the Site. As a visitor to the Site/Customer you are advised to please read the Privacy Policy carefully. By accessing the services provided by the Site, you agree to the collection and use of your data by MIND'S WORKSTATION INDIA PVT. LTD in the manner provided in this Privacy Policy.
              </p>
              <p>
                These Terms of Service ("Terms", "Terms of Service") govern your use of our website located at www.durgapuja.network (together or individually "Service") operated by MIND'S WORKSTATION INDIA PVT. LTD.
              </p>
              <p>
                Our Privacy Policy also governs your use of our Service and explains how we collect, safeguard and disclose information that results from your use of our website www.durgapuja.network.
              </p>
              <p>
                Your agreement with us includes these Terms and our Privacy Policy ("Agreements"). You acknowledge that you have read and understood Agreements, and agree to be bound of them.
              </p>
              <p>
                If you do not agree with (or cannot comply with) Agreements, then you may not use the Service, but please let us know by emailing at hello@durgapuja.network so we can try to find a solution. These Terms apply to all visitors, users and others who wish to access or use Service.
              </p>
            </div>
          </section>

          {/* Services Overview */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-pink/10 rounded-lg mr-3">
                <Users className="h-5 w-5 text-dpn-pink" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Services Overview</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                As part of the registration process on the Site, MIND'S WORKSTATION INDIA PVT. LTD may collect the following personally identifiable information about you: Name including first and last name, alternate email address, mobile phone number and contact details, Postal code, Demographic profile (like your age, gender, occupation, education, address etc.) and information about the pages on the site you visit/access, the links you click on the site, the number of times you access the page and any such browsing information.
              </p>
              <p>
                As the services or offerings evolve, the types of information Durga Puja Network collects may change. Please check this policy frequently for the most current explanation of Durga Puja Network practices.
              </p>
            </div>
          </section>

          {/* Communications */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-light-green/10 rounded-lg mr-3">
                <Calendar className="h-5 w-5 text-dpn-light-green" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Communications</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                By using our Service, you agree to subscribe to newsletters, marketing or promotional materials and other information we may send. However, you may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or by emailing at hello@durgapuja.network.
              </p>
            </div>
          </section>

          {/* Contests, Sweepstakes and Promotions */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-raspberry/10 rounded-lg mr-3">
                <Shield className="h-5 w-5 text-dpn-raspberry" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Contests, Sweepstakes and Promotions</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                Any contests, sweepstakes or other promotions (collectively, "Promotions") made available through Service may be governed by rules that are separate from these Terms of Service. If you participate in any Promotions, please review the applicable rules as well as our Privacy Policy. If the rules for a Promotion conflict with these Terms of Service, Promotion rules will apply.
              </p>
            </div>
          </section>

          {/* Content */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-olive/10 rounded-lg mr-3">
                <FileText className="h-5 w-5 text-dpn-olive" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Content</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). You are responsible for Content that you post on or through Service, including its legality, reliability, and appropriateness.
              </p>
              <p>
                By posting Content on or through Service, You represent and warrant that: (i) Content is yours (you own it) and/or you have the right to use it and the right to grant us the rights and license as provided in these Terms, and (ii) that the posting of your Content on or through Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person or entity. We reserve the right to terminate the account of anyone found to be infringing on a copyright.
              </p>
              <p>
                You retain any and all of your rights to any Content you submit, post or display on or through Service and you are responsible for protecting those rights. We take no responsibility and assume no liability for Content you or any third party posts on or through Service. However, by posting Content using Service you grant us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such Content on and through Service. You agree that this license includes the right for us to make your Content available to other users of Service, who may also use your Content subject to these Terms.
              </p>
              <p>
                MIND'S WORKSTATION INDIA PVT. LTD. has the right but not the obligation to monitor and edit all Content provided by users.
              </p>
              <p>
                In addition, Content found on or through this Service are the property of MIND'S WORKSTATION INDIA PVT. LTD. or used with permission. You may not distribute, modify, transmit, reuse, download, repost, copy, or use said Content, whether in whole or in part, for commercial purposes or for personal gain, without express advance written permission from us.
              </p>
            </div>
          </section>

          {/* Prohibited Uses */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-pink/10 rounded-lg mr-3">
                <AlertCircle className="h-5 w-5 text-dpn-pink" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Prohibited Uses</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>You may use Service only for lawful purposes and in accordance with Terms. You agree not to use Service:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>In any way that violates any applicable national or international law or regulation.</li>
                <li>For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way by exposing them to inappropriate content or otherwise.</li>
                <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail", "chain letter," "spam," or any other similar solicitation.</li>
                <li>To impersonate or attempt to impersonate Company, a Company employee, another user, or any other person or entity.</li>
                <li>In any way that infringes upon the rights of others, or in any way is illegal, threatening, fraudulent, or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful purpose or activity.</li>
                <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of Service, or which, as determined by us, may harm or offend Company or users of Service or expose them to liability.</li>
              </ul>
              <p>Additionally, you agree not to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Use Service in any manner that could disable, overburden, damage, or impair Service or interfere with any other party's use of Service, including their ability to engage in real time activities through Service.</li>
                <li>Use any robot, spider, or other automatic device, process, or means to access Service for any purpose, including monitoring or copying any of the material on Service.</li>
                <li>Use any manual process to monitor or copy any of the material on Service or for any other unauthorized purpose without our prior written consent.</li>
                <li>Use any device, software, or routine that interferes with the proper working of Service.</li>
                <li>Introduce any viruses, trojan horses, worms, logic bombs, or other material which is malicious or technologically harmful.</li>
                <li>Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of Service, the server on which Service is stored, or any server, computer, or database connected to Service.</li>
                <li>Attack Service via a denial-of-service attack or a distributed denial-of-service attack.</li>
                <li>Take any action that may damage or falsify Company rating.</li>
                <li>Otherwise attempt to interfere with the proper working of Service.</li>
              </ul>
            </div>
          </section>

          {/* Analytics */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-light-green/10 rounded-lg mr-3">
                <Globe className="h-5 w-5 text-dpn-light-green" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Analytics</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                We may use third-party Service Providers to monitor and analyse the use of our Service.
              </p>
            </div>
          </section>

          {/* No Use By Minors */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-raspberry/10 rounded-lg mr-3">
                <Users className="h-5 w-5 text-dpn-raspberry" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">No Use By Minors</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                Service is intended only for access and use by individuals at least eighteen (18) years old. By accessing or using Service, you warrant and represent that you are at least eighteen (18) years of age and with the full authority, right, and capacity to enter into this agreement and abide by all of the terms and conditions of Terms. If you are not at least eighteen (18) years old, you are prohibited from both the access and usage of Service.
              </p>
            </div>
          </section>

          {/* Accounts */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-olive/10 rounded-lg mr-3">
                <Shield className="h-5 w-5 text-dpn-olive" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Accounts</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                When you create an account with us, you guarantee that you are above the age of 18, and that the information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on Service.
              </p>
              <p>
                You are responsible for maintaining the confidentiality of your account and password, including but not limited to the restriction of access to your computer and/or account. You agree to accept responsibility for any and all activities or actions that occur under your account and/or password, whether your password is with our Service or a third-party service. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
              </p>
              <p>
                You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity other than you, without appropriate authorization. You may not use as a username any name that is offensive, vulgar or obscene.
              </p>
              <p>
                We reserve the right to refuse service, terminate accounts, remove or edit content, or cancel orders in our sole discretion.
              </p>
            </div>
          </section>

          {/* Copyright & Trademark */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-pink/10 rounded-lg mr-3">
                <FileText className="h-5 w-5 text-dpn-pink" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Copyright & Trademark</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                MIND'S WORKSTATION INDIA PVT. LTD, its suppliers and licensors expressly reserve all intellectual property rights in all text, programs, products, processes, technology, content and other materials, which appear on this Site. Access to this Website does not confer and shall not be considered as conferring upon anyone any license under any of MIND'S WORKSTATION INDIA PVT. LTD or any third party's intellectual property rights.
              </p>
              <p>
                All rights, including copyright, in this website are owned by or licensed to MIND'S WORKSTATION INDIA PVT. LTD Any use of this website or its contents, including copying or storing it or them in whole or part, other than for your own personal, non-commercial use is prohibited without the permission of MIND'S WORKSTATION INDIA PVT. LTD.
              </p>
              <p>
                The names and logos and all related product and service names, design marks and slogans are the trademarks or service marks of MIND'S WORKSTATION INDIA PVT. LTD, its affiliates, its partners or its suppliers. All other marks are the property of their respective companies.
              </p>
            </div>
          </section>

          {/* Limitation of Liability */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-light-green/10 rounded-lg mr-3">
                <AlertCircle className="h-5 w-5 text-dpn-light-green" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Limitation of Liability</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                EXCEPT AS PROHIBITED BY LAW, YOU WILL HOLD US AND OUR OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS HARMLESS FOR ANY INDIRECT, PUNITIVE, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGE, HOWEVER IT ARISES (INCLUDING ATTORNEYS' FEES AND ALL RELATED COSTS AND EXPENSES OF LITIGATION AND ARBITRATION, OR AT TRIAL OR ON APPEAL, IF ANY, WHETHER OR NOT LITIGATION OR ARBITRATION IS INSTITUTED), WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE, OR OTHER TORTIOUS ACTION, OR ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT.
              </p>
              <p>
                SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF PUNITIVE, INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE PRIOR LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU.
              </p>
            </div>
          </section>

          {/* Governing Law */}
          <section>
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-raspberry/10 rounded-lg mr-3">
                <Globe className="h-5 w-5 text-dpn-raspberry" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Governing Law</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                These Terms shall be governed and construed in accordance with the laws of India – Kolkata, which governing law applies to agreement without regard to its conflict of law provisions.
              </p>
              <p>
                Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect.
              </p>
            </div>
          </section>

          {/* Contact Section */}
          <section className="border-t pt-8">
            <div className="flex items-center mb-4">
              <div className="p-2 bg-dpn-olive/10 rounded-lg mr-3">
                <Users className="h-5 w-5 text-dpn-olive" />
              </div>
              <h2 className="text-2xl font-runtime font-bold text-gray-900">Contact Us</h2>
            </div>
            <div className="space-y-4 text-gray-700 font-lucy-rose leading-relaxed">
              <p>
                Please send your feedback, comments, requests for technical support by email: hello@DurgaPuja.Network
              </p>

            </div>
          </section>

        </div>


      </div>
    </div>
  );
};

export default TermsAndConditions;